module.exports = __webpack_public_path__ + "static/media/store04.5a5ce25c.jpg";